import { type StatItem } from "@/components/design-system/StatCard/StatCard";

export const stats: readonly StatItem[] = [
  {
    value: "60%",
    description:
      "of employees report financial stress affects their work — eroding focus, morale and engagement.",
  },
  {
    value: "40%",
    description:
      "of voluntary turnover is financially driven. Replacement costs reach 50–200% of annual salary.",
  },
  {
    value: "3+",
    description:
      "hours a week lost per stressed employee, plus a 17% drop in output while present but stressed.",
  },
  {
    value: "$700",
    description:
      "in extra healthcare per stressed employee, and a record 4.8% raided their 401(k) last year.",
  },
];
